import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import copy from 'copy-to-clipboard';
import React, { useEffect, useState } from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

export const CopyOperationIdTooltip = ({
  operationId,
  children,
}: {
  operationId: string;
  children?: ReactJSXElement;
}) => {
  const [copyOperationIdSuccess, setCopyOperationIdSuccess] =
    useState<boolean>(false);

  useEffect(() => {
    if (copyOperationIdSuccess) {
      const timeout = setTimeout(() => {
        setCopyOperationIdSuccess(false);
      }, 3000);
      return () => clearTimeout(timeout);
    }
  }, [copyOperationIdSuccess]);

  const handleClickEvent = (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
    id: string,
  ) => {
    e.preventDefault();
    e.stopPropagation();
    copy(id);
    setCopyOperationIdSuccess(true);
  };

  return (
    <Tooltip
      label={copyOperationIdSuccess ? 'Copied' : 'Copy Operation ID'}
      openDelay={200}
    >
      <div
        onClick={(e) => {
          handleClickEvent(e, operationId);
        }}
      >
        {children}
      </div>
    </Tooltip>
  );
};
